import React from 'react'
import { Card, CardHeader, Modal, IconButton, CardContent, Typography } from '@mui/material'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'
import { ButtonLoading, InputArea } from '../../Simple'
import { BiX } from 'react-icons/bi'

export default function CancelarDiaria({ show, onClose }) {
  const { sttCtxAgend, loadAgend, actionsDiaria } = React.useContext(AgendamentoContext)

  const [motivo, setMotivo] = React.useState('')

  function ActionCancel() {
    actionsDiaria.CancelarDiaria(motivo)
  }

  return (
    <Modal open={show} onClose={onClose} className='contain-overlay-obs'>
      <Card className='contain-content-obs'>
        <CardHeader
          classes={{ action: 'card-header-action' }}
          sx={{ padding: '5px' }}
          action={
            <IconButton
              aria-label='close'
              className='icon-close-modal'
              onClick={onClose}
              style={{ margin: '5px 10px 0px 0px' }}
            >
              <BiX size={30} />
            </IconButton>
          }
          title={
            <Typography variant='h6' component='div' className='card-header-title'>
              Cancelar Diária
            </Typography>
          }
        />
        <CardContent sx={{ width: '100%', padding: '5px' }}>
          <Typography
            color='textSecondary'
            component='h4'
            className='text-label-AC'
            align='justify'
          >
            {sttCtxAgend.diariaSel?.dayuse.formaPagamento === 'LOCAL'
              ? 'O pagamento desta diária será realizado localmente. Se você cancelar, ela será automaticamente cancelada e não poderá ser recuperada.'
              : 'Esta diária foi paga pelo aplicaitov. Se você cancelar, receberá o estorno total do valor.'}
          </Typography>
          {sttCtxAgend.diariaSel?.dayuse.usuarioPodeCancelar === 'DIA' && (
            <Typography
              color='textSecondary'
              component='h4'
              className='text-label-AC'
              align='justify'
            >
              {`Você pode cancelar esta diária até 24 horas antes do início da mesma.`}
            </Typography>
          )}
          <InputArea
            label='Qual o motivo do cancelamento?'
            value={motivo}
            onChange={e => setMotivo(e.target.value)}
            sx={{ marginTop: '5px' }}
          />
          <ButtonLoading
            fullWidth
            label='Aplicar Cupom'
            loading={loadAgend.cancelamentoDiaria}
            disabled={motivo.length < 5}
            sx={{ marginTop: '5px' }}
            onClick={() => {
              ActionCancel()
            }}
          >
            Cancelar Diária
          </ButtonLoading>
        </CardContent>
      </Card>
    </Modal>
  )
}
